module.exports = __webpack_public_path__ + "img/seychelles.ab20ca36.png";